<vw-modal [isOpen]="isOpen" [showCloseIcon]="false" width="340px" (close)="cancelled.emit()">
  <div modalHeader class="flex items-center gap-2 px-1">
    <span class="text-xl">⚠️</span>
    <h2 class="text-base font-semibold text-[#023E42]">{{ title }}</h2>
  </div>
  <div modalBody class="px-1 py-2">
    <p class="text-sm leading-snug text-[#545F5A]">{{ message }}</p>
  </div>
  <div modalFooter class="flex gap-2 px-1 pt-3">
    <button type="button" (click)="cancelled.emit()" [disabled]="loading"
      class="flex-1 rounded-full border border-gray-200 py-2.5 text-sm font-medium text-[#545F5A] disabled:opacity-60">
      {{ cancelLabel || ('common.cancel' | translate) }}
    </button>
    <button type="button" (click)="confirmed.emit()" [disabled]="loading"
      class="flex-1 rounded-full py-2.5 text-sm font-semibold text-white disabled:opacity-60"
      [ngClass]="danger ? 'bg-[#F05450]' : 'bg-primary'">
      {{ loading ? ('common.loading' | translate) : confirmLabel }}
    </button>
  </div>
</vw-modal>
